import { cn } from "@/lib/utils";

export function SoonBadge({ className }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center whitespace-nowrap rounded-full border border-brand-teal/40 bg-brand-teal/15 px-2.5 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-brand-blue",
        className,
      )}
    >
      Em breve
    </span>
  );
}

export function AccessLink({
  href,
  external = false,
  className,
  testId,
  ariaLabel,
  children,
  onInternalNavigate,
  onClick,
  badgeClassName = "",
  showBadge = true,
}) {
  if (!href) {
    return (
      <span
        data-testid={testId}
        aria-disabled="true"
        title="Em breve"
        className={cn("relative cursor-not-allowed select-none", className)}
        onClick={onClick}
      >
        {children}
        {showBadge && <SoonBadge className={badgeClassName} />}
      </span>
    );
  }

  if (external) {
    return (
      <a
        data-testid={testId}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
        className={className}
        onClick={onClick}
      >
        {children}
        <span className="sr-only">(abre em nova aba)</span>
      </a>
    );
  }

  return (
    <a
      data-testid={testId}
      href={href}
      aria-label={ariaLabel}
      className={className}
      onClick={(e) => {
        if (onInternalNavigate) {
          e.preventDefault();
          onInternalNavigate(href);
        }
        onClick?.(e);
      }}
    >
      {children}
    </a>
  );
}
